import React from "react";

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconSalesExport: React.FC<IconProps> = ({
  size = 18,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 16"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.56253 0C9.45554 0.000234981 10.9911 1.5347 10.9912 3.42773V3.95605H12.4141C13.0233 3.95616 13.5343 4.41662 13.5977 5.02246L13.92 8.11719L14.6787 13.7676C14.7745 14.4812 14.2191 15.1162 13.4991 15.1162H1.56449C0.836457 15.1159 0.27847 14.4669 0.387727 13.7471L1.72074 4.9668C1.80927 4.38581 2.30979 3.95634 2.89749 3.95605H4.1348V3.42773C4.13492 1.53478 5.66964 0.000375324 7.56253 0ZM2.89749 4.74902C2.70193 4.74931 2.5356 4.89266 2.50589 5.08594L1.17191 13.8662C1.13554 14.106 1.322 14.322 1.56449 14.3223H13.4991C13.7391 14.3223 13.9245 14.1109 13.8926 13.873L13.1319 8.21094L13.1309 8.19922L12.8086 5.10449C12.7873 4.9028 12.6169 4.74913 12.4141 4.74902H2.89749ZM10.3125 10.8857C10.4964 10.8859 10.6455 11.0349 10.6455 11.2188V11.6934C10.6451 12.2447 10.198 12.6922 9.64652 12.6924H5.64945C5.09791 12.6923 4.65084 12.2448 4.65042 11.6934V11.2188C4.65042 11.0348 4.79948 10.8857 4.98343 10.8857C5.16728 10.8859 5.31644 11.0349 5.31644 11.2188V11.6934C5.31685 11.8769 5.46581 12.0263 5.64945 12.0264H9.64652C9.83006 12.0262 9.97911 11.8768 9.97952 11.6934V11.2188C9.97952 11.0348 10.1286 10.8857 10.3125 10.8857ZM7.29788 6.49219C7.47772 6.32197 7.74719 6.30003 7.94925 6.42773L8.03128 6.49219L9.55374 7.93457C9.68683 8.06107 9.69269 8.27186 9.56644 8.40527C9.43998 8.538 9.22907 8.54389 9.09574 8.41797L7.9971 7.37695V10.9023C7.99702 11.0862 7.8479 11.2352 7.66409 11.2354C7.48049 11.235 7.33117 11.086 7.33109 10.9023V7.37695L6.23343 8.41797C6.09995 8.54391 5.88813 8.53837 5.76175 8.40527C5.63572 8.27201 5.64183 8.0611 5.77445 7.93457L7.29788 6.49219ZM7.56253 0.792969C6.10774 0.793344 4.92789 1.97288 4.92777 3.42773V3.95605H10.1973V3.42773C10.1972 1.9728 9.01744 0.793204 7.56253 0.792969Z"
      fill="currentColor"
    />
  </svg>
);

export default IconSalesExport;
